@if (showBusyIndicator) {
<busy-indicator [page]="true" [overlay]="true" [message]="busyMessage"></busy-indicator>
}

@if (loaded) {
<forge-scaffold [hidden]="navigating || multipleEditLoading">
    <div slot="body" fxLayout="row" fxLayoutAlign="center start">
        <form #formCtrl="ngForm" fxFlex>
            @if (IsStepper) {
            <div fxLayout="row" fxLayoutAlign="center start" fxFlex="100">
                <forge-card class="metadata-form--card no-padding"
                    [ngClass]="{'metadata-form--card-embedded': isEmbedded, 'compact': compactMode, 'provisional': isProvisional}">
                    <forge-scaffold>
                        <div slot="body-header">
                            <div class="metadata-form--stepper-header">
                                <forge-stepper alternative [attr.selected-index]="selectedIndex"
                                    (forge-step-select)="stepperSelectionChange($event)">
                                    @for (step of getViews(); track step) {
                                    <forge-step [attr.disabled]="StepDisabled(step)"
                                        [attr.completed]="StepIsCompleted(getIndex(step))"
                                        [attr.selected]="StepIsSelected(getIndex(step)) ? '' : null"
                                        alternative [attr.index]="getIndex(step)">
                                        <div
                                            style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                            {{step.Title}}
                                        </div>
                                    </forge-step>
                                    }
                                </forge-stepper>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="end start" fxFill>
                                @if (!navigating && !saving && !canceling) {
                                <metadata-action-menu [metadataActions]="formActions" [model]="currentModel"
                                    [formData]="currentDataController" fxLayout="row" fxLayoutAlign="end center">
                                </metadata-action-menu>
                                }
                            </div>
                        </div>
                        <div slot="body">
                            <forge-view-switcher [attr.index]="selectedIndex" animation-type="slide"
                                class="metadata-stepper">
                                @for (step of getAllViews(); track step; let i = $index)
                                {
                                @if (isSelectedView(step) && !refreshing) {
                                <forge-view>
                                    <metadata-view [id]="'formView' + i" [parentViewId]="'formView' + i"
                                        ngModelGroup="formView{{i}}" fxFill [viewTitle]="step.Title" [view]="step"
                                        [datacontroller]="currentDataController" [model]="currentModel"
                                        [viewOnly]="isViewOnly" [onDelete]="onDeleteBind()"
                                        [saveableForm]="!hideActions" [customViewCommands]="viewCommands"
                                        (modifierCallback)="modifierCallbackBind($event)" [index]="getIndex(step)"
                                        [selectedIndex]="selectedIndex" [isStepperView]="true">
                                    </metadata-view>
                                </forge-view>
                                }
                                }
                            </forge-view-switcher>
                        </div>
                        <div slot="body-footer" class="metadata-form--footer" [ngClass]="{'compact': compactMode}">
                            <div fxLayout="row" fxLayoutAlign="end center" class="form-actions-container">
                                <forge-button [dense]="compactMode" variant="outlined" telemetry="Submission-Cancel"
                                    (click)="cancel()" [disabled]="recalculating" class="metadata-form--footer-button">
                                    Cancel
                                </forge-button>
                                @if (selectedIndex != 0) {
                                <forge-button [dense]="compactMode" variant="outlined" telemetry="Submission-Previous"
                                    [disabled]="SelectedViewCellEditing() || recalculating" (click)="previous()"
                                    aria-keyshortcuts="Shift+ArrowLeft" class="metadata-form--footer-button">
                                    Previous
                                </forge-button>
                                }
                                @if (!LastStep()) {
                                <div fxLayout="row" fxLayoutAlign="end center">
                                    @if (!remainingStepsOptional() || hasActionOverrides()) {
                                    <forge-button [dense]="compactMode" variant="outlined"
                                        [disabled]="!StepControlsEnabled() || recalculating" telemetry="Submission-Next"
                                        (click)="next()" aria-keyshortcuts="Shift+ArrowRight"
                                        class="metadata-form--footer-button">
                                        Next
                                    </forge-button>
                                    }
                                    @if (remainingStepsOptional() && !hasActionOverrides()) {
                                    <forge-split-button [dense]="compactMode" variant="outlined" theme="primary">
                                        <forge-button [dense]="compactMode" variant="outlined"
                                            [disabled]="!StepControlsEnabled() || recalculating"
                                            telemetry="Submission-Next" (click)="next()"
                                            aria-keyshortcuts="Shift+ArrowRight">
                                            Next
                                        </forge-button>
                                        @if (remainingStepsOptional()) {
                                        <forge-menu [options]="saveEarlyOptions" placement="top-end"
                                            highlight-first="false" [dense]="compactMode"
                                            (forge-menu-select)="saveAction($event)"
                                            (forge-menu-open)="menuOpened($event)">
                                            <forge-button [dense]="compactMode" variant="outlined"
                                                [disabled]="!StepControlsEnabled() || recalculating"
                                                aria-label="save options" telemetry="save options">
                                                <forge-icon name="keyboard_arrow_down"></forge-icon>
                                            </forge-button>
                                        </forge-menu>
                                        }
                                    </forge-split-button>
                                    }
                                    @if (remainingStepsOptional() && hasActionOverrides()) {
                                    <div fxLayout="row" fxLayoutAlign="end center">
                                        @for (action of getActionOverrides(); track action) {
                                        <div>
                                            @if (!isViewOnly && !IsActionHidden(action) && canCancel) {
                                            <forge-button [dense]="compactMode" variant="outlined"
                                                [disabled]="!canSave() || recalculating"
                                                attr.telemetry="Submission-{{saveLabel}}"
                                                (mousedown)="maybeWaitForRecalculate($event, action)"
                                                (click)="maybeWaitForRecalculateClick($event, action)"
                                                class="metadata-form--footer-button">
                                                {{action.Label}}
                                            </forge-button>
                                            }
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                @if (!hasActionOverrides() && loaded && LastStep() && !isViewOnly) {
                                <div>
                                    @if (showAddAnother) {
                                    <forge-split-button [dense]="compactMode" variant="outlined" theme="primary">
                                        <forge-button [dense]="compactMode" variant="outlined"
                                            [disabled]="!StepControlsEnabled()" telemetry="Submission-Save"
                                            (mousedown)="maybeWaitForRecalculate($event)"
                                            (click)="maybeWaitForRecalculateClick($event)"
                                            aria-keyshortcuts="Shift+ArrowRight" selenium-tag="save-btn">
                                            {{saveButtonText}}
                                        </forge-button>
                                        <forge-menu [options]="saveOptions" placement="top-end" highlight-first="false"
                                            [dense]="compactMode" (forge-menu-select)="saveAction($event)"
                                            (forge-menu-open)="menuOpened($event)">
                                            <forge-button [dense]="compactMode" variant="outlined"
                                                [disabled]="!StepControlsEnabled()"
                                                aria-label="Save-keyboard_arrow_down">
                                                <forge-icon name="keyboard_arrow_down"></forge-icon>
                                            </forge-button>
                                        </forge-menu>
                                    </forge-split-button>
                                    }
                                    @if (!showAddAnother) {
                                    <forge-button [dense]="compactMode" variant="outlined"
                                        [disabled]="!StepControlsEnabled()" telemetry="Submission-Save"
                                        (mousedown)="maybeWaitForRecalculate($event)"
                                        (click)="maybeWaitForRecalculateClick($event)"
                                        aria-keyshortcuts="Shift+ArrowRight" class="metadata-form--footer-button"
                                        selenium-tag="save-btn">
                                        {{saveButtonText}}
                                    </forge-button>
                                    }
                                </div>
                                }
                                @if (hasActionOverrides()) {
                                <div fxLayout="row" fxLayoutAlign="end center">
                                    @for (action of getActionOverrides(); track action) {
                                    <div>
                                        @if (LastStep() && !isViewOnly && !IsActionHidden(action) && canCancel) {
                                        <forge-button [dense]="compactMode" variant="outlined" [disabled]="!canSave()"
                                            attr.telemetry="Submission-{{saveLabel}}"
                                            (mousedown)="maybeWaitForRecalculate($event, action)"
                                            (click)="maybeWaitForRecalculateClick($event, action)"
                                            class="metadata-form--footer-button">
                                            {{action.Label}}
                                        </forge-button>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </forge-scaffold>
                </forge-card>
            </div>
            }
            @if (!IsStepper) {
            <div fxLayout="row" fxLayoutAlign="center start" fxFlex="100">
                <forge-card class="metadata-form--card no-padding"
                    [ngClass]="{'metadata-form--card-embedded': isEmbedded, 'compact': compactMode, 'provisional': isProvisional}">
                    <forge-scaffold>
                        @if (showTitleOnForm || hasFormActions) {
                        <forge-toolbar slot="body-header" no-divider class="metadata-form--header"
                            [ngClass]="compactMode ? 'compact' : ''" style="display: block;">
                            @if (showTitleOnForm) {
                            <h1 slot="start" fxLayoutAlign="start center" fxLayout="row" class="tyl-card--header"
                                [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'">
                                {{title}}
                            </h1>
                            }
                            <div [hidden]="!showHeaderBadge" slot="start" class="tt-margin--left" fxLayout="row"
                                fxLayoutAlign="start center">
                                @for (badge of visibleHeaderBadges; track badge) {
                                <forge-badge [theme]="getTheme(badge)">
                                    {{badge.Text}}
                                </forge-badge>
                                }
                            </div>
                            @if (!navigating && !saving && !canceling) {
                            <metadata-action-menu slot="end" [metadataActions]="formActions" [model]="currentModel"
                                [formData]="currentDataController" fxLayout="row" fxLayoutAlign="end center">
                            </metadata-action-menu>
                            }
                        </forge-toolbar>
                        }
                        @if (shouldShowNav) {
                        <metadata-view-navigation-list [ngClass]="{'compact': compactMode}" ngModelGroup="navList"
                            slot="body-left" [formMetadata]="currentForm" [formId]="currentForm.FormId"
                            [model]="currentModel" [datacontroller]="currentDataController" (onSelect)="select($event)"
                            [viewOnly]="isViewOnly" [selectedView]="selectedView">
                        </metadata-view-navigation-list>
                        }
                        <div slot="body" fxLayout="column" class="content-form" [ngClass]="{'nav-list-form': isNavForm}"
                            style="margin-left: -1px;">
                            @for (view of getAllViews(); track view; let i = $index)
                            {
                            @if (isSelectedView(view) && !refreshing) {
                            <div [ngStyle]="isSelectedView(view) ? {'height':'100%'} : {}">
                                <metadata-view [id]="'formView' + i" [parentViewId]="'formView' + i"
                                    ngModelGroup="formView{{i}}" fxFill fxLayout="column" [hideTitle]="showTitleOnForm"
                                    [viewTitle]="title" [view]="view" [datacontroller]="currentDataController"
                                    [model]="currentModel" [viewOnly]="isViewOnly" [saveableForm]="!hideActions"
                                    [onDelete]="onDeleteBind()" (modifierCallback)="modifierCallbackBind($event)"
                                    [customViewCommands]="viewCommands">
                                </metadata-view>
                            </div>
                            }
                            }
                        </div>
                        @if (hasFooterView() || !hideActions) {
                        <div slot="body-footer" class="metadata-form--footer" [ngClass]="{'compact': compactMode}">
                            @if (hasFooterView()) {
                            <div class="metadata-form--footer-view">
                                <metadata-view ngModelGroup="footer" fxFill [model]="currentModel" [footerView]="true"
                                    [datacontroller]="currentDataController" [view]="getFooterView()">
                                </metadata-view>
                            </div>
                            }
                            @if (!hideActions) {
                            <div class="form-buttons--no-background" fxLayout="row" fxLayoutAlign="end end">
                                <div class="form-actions-container" fxLayout="row" fxLayoutAlign="end center"
                                    fxFlex="100">
                                    @if (multipleEdit && !saving && !showLoading) {
                                    <forge-paginator (forge-paginator-change)="paginatorChange($event)"
                                        [pageIndex]="editFormIndex" first-last="true" alternative
                                        [total]="multipleEditTotal" page-size="1">
                                    </forge-paginator>
                                    }
                                    @if (canCancel && !hideCancelWithActionOverrides()) {
                                    <forge-button [dense]="compactMode" variant="outlined" telemetry="Submission-Cancel"
                                        (click)="cancel()" class="tt-margin--left" tabindex="0">
                                        {{cancelLabel}}
                                    </forge-button>
                                    }
                                    @if (!hasActionOverrides() && loaded) {
                                    <div>
                                        @if (showAddAnother) {
                                        <forge-split-button [dense]="compactMode" variant="raised" theme="primary">
                                            <forge-button [dense]="compactMode" variant="raised" [disabled]="!canSave()"
                                                attr.telemetry="Submission-{{saveLabel}}"
                                                (mousedown)="maybeWaitForRecalculate($event)"
                                                (click)="maybeWaitForRecalculateClick($event)" tabindex="0"
                                                selenium-tag="save-btn">
                                                {{saveButtonText}}
                                            </forge-button>
                                            @if (!navigating && showAddAnother) {
                                            <forge-menu [options]="saveOptions" placement="top-end"
                                                highlight-first="false" [dense]="compactMode"
                                                (forge-menu-select)="saveAction($event)"
                                                (forge-menu-open)="menuOpened($event)">
                                                <forge-button [dense]="compactMode" variant="raised"
                                                    [disabled]="!canSave()" aria-label="Save and New Expandable">
                                                    <forge-icon name="keyboard_arrow_down"></forge-icon>
                                                </forge-button>
                                            </forge-menu>
                                            }
                                        </forge-split-button>
                                        }
                                        @if (!showAddAnother) {
                                        <forge-button [dense]="compactMode" variant="raised" [disabled]="!canSave()"
                                            attr.telemetry="Submission-{{saveLabel}}"
                                            (mousedown)="maybeWaitForRecalculate($event)"
                                            (click)="maybeWaitForRecalculateClick($event)" tabindex="0"
                                            class="metadata-form--footer-button" selenium-tag="save-btn">
                                            {{saveButtonText}}
                                            @if (recalculating || saving) {
                                            <forge-circular-progress slot="end"></forge-circular-progress>
                                            }
                                        </forge-button>
                                        }
                                    </div>
                                    }
                                    @if (hasActionOverrides()) {
                                    <div fxLayout="row">
                                        @for (action of getActionOverrides(); track action) {
                                        <div class="form-override-actions--container">
                                            @if (!IsActionHidden(action) && !showCompoundSaveButton) {
                                            <forge-button [dense]="compactMode" variant="outlined"
                                                [disabled]="!canSave()" attr.telemetry="Submission-{{action.Label}}"
                                                (mousedown)="maybeWaitForRecalculate($event, action)"
                                                (click)="maybeWaitForRecalculateClick($event, action)"
                                                class="metadata-form--footer-button" selenium-tag="save-btn">
                                                {{getOverrideLabel(action)}}
                                            </forge-button>
                                            }
                                        </div>
                                        }
                                        @if (showCompoundSaveButton) {
                                        <div>
                                            <forge-split-button [dense]="compactMode" variant="raised" theme="primary">
                                                <forge-button [dense]="compactMode" variant="raised"
                                                    [disabled]="!canSave()"
                                                    attr.telemetry="Submission-{{currentCompoundSaveOption}}"
                                                    (mousedown)="maybeWaitForCompoundRecalculate($event)"
                                                    (click)="maybeWaitForCompoundRecalculateClick($event)"
                                                    selenium-tag="save-btn">
                                                    {{currentCompoundSaveOption}}
                                                </forge-button>
                                                <forge-menu [options]="compoundSaveOptions" placement="top-end"
                                                    highlight-first="false" [dense]="compactMode"
                                                    (forge-menu-select)="saveCompound($event)"
                                                    (forge-menu-open)="menuOpened($event)">
                                                    <forge-button [dense]="compactMode" variant="raised"
                                                        [disabled]="!canSave()" aria-label="Save-keyboard_arrow_down">
                                                        <forge-icon name="keyboard_arrow_down"></forge-icon>
                                                    </forge-button>
                                                </forge-menu>
                                            </forge-split-button>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </forge-scaffold>
                </forge-card>
            </div>
            }
        </form>
    </div>
</forge-scaffold>
}